import Hero from '../components/Hero';
import FeatureShuffler from '../components/FeatureShuffler';
import FeatureTypewriter from '../components/FeatureTypewriter';
import FeatureScheduler from '../components/FeatureScheduler';
import Philosophy from '../components/Philosophy';
import ProtocolStack from '../components/ProtocolStack';
import EngagementTiers from '../components/EngagementTiers';
import Testimonials from '../components/Testimonials';
import MagneticButton from '../components/MagneticButton';
import FeaturedVideos from '../components/FeaturedVideos';
import { useDocumentMeta } from '../lib/useDocumentMeta';

export default function Home() {
  useDocumentMeta({
    title: 'Samia Systems — Intelligence. Engineered.',
    description:
      'Engineering-grade AI automation for professional services firms. Every engagement begins with a Technical Blueprint.',
  });
  return (
    <>
      <Hero />
      <FeaturedVideos />
      <Testimonials />

      <section className="grain bg-black py-32">
        <div className="container-x">
          <div className="mb-16 max-w-3xl">
            <p className="label mb-6 inline-flex items-center gap-3">
              <span className="h-px w-10 bg-gold" />
              The Practice
            </p>
            <h2 className="font-display text-section font-light text-white text-balance">
              Three artefacts. One discipline.
            </h2>
            <p className="mt-6 max-w-xl font-sans text-body text-white/85">
              The Blueprint, the telemetry, the cadence. The visible outputs of
              an engineering-grade practice.
            </p>
          </div>

          <div className="grid gap-6 lg:grid-cols-3">
            <FeatureShuffler />
            <FeatureTypewriter />
            <FeatureScheduler />
          </div>
        </div>
      </section>

      <Philosophy />
      <ProtocolStack />
      <EngagementTiers />

      <section className="grain relative bg-black py-32">
        <div className="container-x">
          <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
            <p className="label mb-6 inline-flex items-center gap-3">
              <span className="h-px w-10 bg-gold" />
              Begin
            </p>
            <h2 className="font-display text-section font-light text-white text-balance">
              Every project begins with a Diagnostic.
            </h2>
            <p className="mt-6 max-w-xl font-sans text-body text-white/85">
              Thirty minutes. We listen. You leave with a structured view of
              what to build, what to defer, and what to measure.
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <MagneticButton to="/book">Book a Diagnostic</MagneticButton>
              <MagneticButton to="/library" variant="ghost">
                Sample Blueprint
              </MagneticButton>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
